//存储在local 里面的所有信息

export  function getToken() {
    return localStorage.getItem("token");
}


export  function getLoginuserId() {
    return JSON.parse(localStorage.getItem("user")).id;
}

export  function getLoginuserDepart() {
    return JSON.parse(localStorage.getItem("user")).orgCode;
}


export function saveDepoartmentId(id) {
    localStorage.setItem("depoartmentId", id);
}

//科室编号
export function getDepoartmentId() {
    return localStorage.getItem("depoartmentId");
}


export function getUsername() {
    return localStorage.getItem("username");
}

export function getRealname() {
    return localStorage.getItem("realname");
}

